import React from "react";
import { DatePicker } from "antd";

const { RangePicker } = DatePicker;

const AntDDatePicker = ({
  type = "single",          // "single" | "range"
  value,
  onChange,

  /* Display */
  format = "DD/MM/YYYY",    // format="DD/MM/YYYY" for date picker
  placeholder,
  showTime = false,         // showTime={true} or false

  /* Behavior */
  multiple = false,         // AntD v5 supported
  allowClear = true,        // allowClear={true} or false
  disabled = false,         // disabled={true} or false

  /* Misc */
  name,
  suffixIcon,
  className = "",      

  ...rest
}) => {
  const PickerComponent = type === "range" ? RangePicker : DatePicker;

  return (
    <div className={`SwAntDPicker ${className}`}>
      <PickerComponent
        name={name}
        value={value}
        onChange={onChange}
        format={format}
        showTime={showTime}
        placeholder={placeholder}
        allowClear={allowClear}
        disabled={disabled}
        multiple={type === "single" ? multiple : undefined}
        suffixIcon={suffixIcon}
        {...rest}
      />
    </div>
  );
};

export default AntDDatePicker;
